import { render, staticRenderFns } from "./FreeAgentCard.vue?vue&type=template&id=4ecdc1b6&scoped=true&"
import script from "./FreeAgentCard.vue?vue&type=script&lang=js&"
export * from "./FreeAgentCard.vue?vue&type=script&lang=js&"
import style0 from "./FreeAgentCard.vue?vue&type=style&index=0&id=4ecdc1b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecdc1b6",
  null
  
)

export default component.exports